/**
 * RTWO Native Currency Engine — Economic Parameter Service
 */

import { RTWO_ECONOMIC_PARAMETERS } from '../domain-models';
import type { ParameterId, RTWOProtocolEconomicParameter } from '../domain-models';
import type { EconomicParameterResult, IEconomicParameterService } from '../service-interfaces';
import { NATVInternalEventTypes } from '../events/natv-event-bus';
import { BaseNATVService, type NATVServiceContext } from './base-natv-service';

export class EconomicParameterService extends BaseNATVService implements IEconomicParameterService {
  readonly serviceId = 'natv-economic-parameter-001';
  readonly serviceName = 'Economic Parameter Service';
  readonly description =
    '8 RTWO economic parameters defined — architecture phase. Governance-controlled parameters require future Governance Runtime.';
  readonly integrations = ['Core Engine', 'Governance (future)', 'System Registry'];
  readonly requiresGenesisConfiguration = false;
  readonly requiresLedgerConnection = false;

  constructor(context: NATVServiceContext) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'structure_ready';
  }

  async updateParameter(
    parameterId: ParameterId,
    valueReference: string
  ): Promise<EconomicParameterResult> {
    this.context.eventBus.emit(NATVInternalEventTypes.PARAMETER_UPDATED, {
      parameterId,
      valueReference,
    });

    return {
      success: false,
      parameterId: null,
      error: 'Parameter updates require Governance Runtime — Future Phase',
      isPlaceholder: true,
      source: 'Native Currency Engine — Governance Runtime — Future Phase',
    };
  }

  getAllParameters(): RTWOProtocolEconomicParameter[] {
    return RTWO_ECONOMIC_PARAMETERS;
  }

  getParameter(parameterId: ParameterId): RTWOProtocolEconomicParameter | null {
    return (
      RTWO_ECONOMIC_PARAMETERS.find((parameter) => parameter.parameterId === parameterId) ?? null
    );
  }

  getParametersByType(parameterType: string): RTWOProtocolEconomicParameter[] {
    return RTWO_ECONOMIC_PARAMETERS.filter(
      (parameter) => parameter.parameterType === parameterType
    );
  }

  getGovernanceControlledParameters(): RTWOProtocolEconomicParameter[] {
    return RTWO_ECONOMIC_PARAMETERS.filter((parameter) => parameter.governanceControlled);
  }
}
